<template>
    <front-layout>
        <Head>
            <title>{{ job.title }}</title>
            <meta head-key="description" name="description" :content="job.description" />
        </Head>
        <div class="fixed top-0 left-0 w-full min-h-full block bg-opacity-80 z-50 bg-gray-900 pointer-events-none no-print" v-if="showReplyForm"></div>

        <div class="pt-40">
            <img v-if="job.category_id && job.category.image" :src="'/storage/categories/' + job.category.image" alt="imagem categoria" class="grayscale w-full h-[28vh] print:h-[10vh] object-cover">
        </div>
  
        <div class="container mx-auto px-4 pb-40">
            <div class="flex flex-col md:flex-row md:space-x-4">
                <div class="w-3/4 py-10 mt-1 relative print print:text-sm">
                    <h1 class="text-3xl font-bold">{{ job.title }}</h1>
                    <p class="text-sm text-gray-400 tracking-wide mt-2">{{job.freguesia}} - {{ job.distrito }} | categoria: <a href="#" class="text-violet-500 text-sm" v-if="job.category_id">{{ job.category.name }}</a></p>
        
                    <hr class="my-2">
                    <div v-if="job.description">
                        <p class="font-bold text-sm">Descrição</p>
                        <p v-html="job.description"></p>
                    </div>
                    <div v-if="job.functions" class="mt-4">
                        <p class="font-bold text-sm">Funções</p>
                        <p v-html="job.functions"></p>
                    </div>
                    <div v-if="job.reqs" class="mt-4">
                        <p class="font-bold text-sm">Requisitos</p>
                        <p v-html="job.reqs"></p>
                    </div>
                    <div v-if="job.offers" class="mt-4">
                        <p class="font-bold text-sm">Oferece-se</p>
                        <p v-html="job.offers"></p>
                    </div>
                    <div v-if="job.notes" class="mt-4">
                        <p class="font-bold text-sm">Notas</p>
                        <p v-html="job.notes"></p>
                    </div>

                    <hr class="my-2">

                    <p class="mt-4 text-gray-500 text-sm print">Todas as candidaturas serão tratadas com confidencialidade ao abrigo da Lei de Proteção de Dados.<br>Consulte a Política de Privacidade da Pessoalform <a :href="route('pol_privacidade')" class="text-violet-500">aqui</a></p>
                </div>

                <div class="flex-auto md:mt-8 top-12 relative no-print">
                    <div class="p-4 bg-violet-500 hover:bg-violet-600 shadow-md rounded-full mt-4 text-center">
                        <jet-button @click.prevent="showReplyForm = true" class="bg-transparent hover:bg-transparent active:bg-transparent border-0 focus:ring-0">Candidatar-me a esta oferta</jet-button>
                    </div>
                    <div class="p-4 bg-white shadow-md rounded-full mt-4 text-center">
                        <a :href="route('contactos')" class="hover:text-violet-500 flex flex-row space-x-2 items-center w-full group">
                            <icon name="chat" class="w-8 h-8 rounded-full p-1 border border-gray-900 group-hover:border-violet-500" />
                            <span>contacte-nos</span>
                        </a>
                    </div>
                    <div class="p-4 bg-white shadow-md rounded-full mt-4">
                        <a :href="url" target="_blank" class="hover:text-violet-500 flex flex-row space-x-2 items-center w-full group">
                            <icon name="facebook" class="w-8 h-8 rounded-full p-1 border border-gray-900 group-hover:border-violet-500" />
                            <span>Partilhar no facebook</span>
                        </a>
                    </div>
                    <div class="p-4 bg-white shadow-md rounded-full mt-4 text-center">
                        <button @click="print" class="hover:text-violet-500 flex flex-row space-x-2 items-center w-full group">
                            <icon name="print" class="w-8 h-8 rounded-full p-1 border border-gray-900 group-hover:border-violet-500" />
                            <span>Imprimir Oferta</span>
                        </button>
                    </div>

                     <!-- form -->
                    <div class="border fixed top-0 right-0 bg-white p-6 shadow-xl z-50 overflow-y-auto transition-all h-full w-full lg:w-1/2" :class="showReplyForm ? 'right-0' : '-right-[100vw]'">
                          
                        <h3 class="font-bold text-xl">{{ job.title }}</h3>

                         <p class="text-violet-500 text-sm my-2">Todos os campos são de preenchimento obrigatório.</p>

                    
                        <form @submitted="createCandidato" class="w-full border-t pt-8 overflow-y-auto">
                            <!-- Nome -->
                            <div>
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="nome" value="Nome Completo" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.nome" />
                                </div>
                               
                                <jet-input type="text" v-model="form.nome" class="w-full"/>
                            </div>

                            <div class="flex space-x-4 w-full mt-2">
                                <!-- Documento ident. -->
                                <div class="flex-1">
                                    <div class="flex flex-row space-x-2">
                                        <jet-label for="doc_tipo" value="Doc. de identificação" class="font-bold text-xs" />
                                        <jet-input-error :message="form.errors.doc_tipo" />
                                    </div>
                                    <select-input name="form.doc_tipo" v-model="form.doc_tipo" label="">
                                        <option value="" disabled>Documento</option>
                                        <option value="Cartão de Cidadão">Cartão de Cidadão</option>
                                        <option value="Título de Residência">Título de Residência</option>
                                        <option value="Manifestação de Interesse">Manifestação de Interesse</option>
                                        <option value="Passaporte">Passaporte</option>
                                    </select-input>   
                                </div>
                                <!-- doc_num -->
                                <div class="flex-1">
                                    <div class="flex flex-row space-x-2">
                                        <jet-label for="doc_num" value="Doc. nº" class="font-bold text-xs" />
                                        <jet-input-error :message="form.errors.doc_num" />
                                    </div>
                                    <jet-input type="text" v-model="form.doc_num" class="w-full" min="8" max="8"/>
                                </div>
                            </div>

                            <!-- data nasc. - nif -->
                            <div class="mt-2 flex flex-row space-x-2">
                                <!-- nif -->
                                <div class="w-full">
                                    <div class="flex flex-row space-x-2">
                                        <jet-label for="nif_num" value="NºContribuinte" class="font-bold text-xs" />
                                        <jet-input-error :message="form.errors.nif_num" />
                                    </div>
                                    <jet-input type="text" v-model="form.nif_num" class="w-full" max="9"/>
                                </div>
                              
                                <!-- data nac -->
                                <div class="w-full">
                                    <div class="flex flex-row space-x-2">
                                        <jet-label for="data_nasc" value="Data Nascimento" class="font-bold text-xs" />
                                        <jet-input-error :message="form.errors.data_nasc" />
                                    </div>
                                    <jet-input type="date" v-model="form.data_nasc" class="w-full" max="9"/>
                                </div>
                            </div>
                           
                            <!-- Morada -->
                            <div class="mt-2">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="morada" value="Morada" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.morada" />
                                </div>
                                <text-area-input v-model="form.morada" rows="2" class="w-full"></text-area-input>
                            </div>
                            <div class="flex space-x-4 w-full mt-2">
                                <!-- Cod postal -->
                                <div class="flex-2">
                                    <div class="flex flex-row space-x-2">
                                        <jet-label for="cod_postal" value="Cód. Postal" class="font-bold text-xs" />
                                        <jet-input-error :message="form.errors.cod_postal" />
                                    </div>
                                    <jet-input type="text" v-model="form.cod_postal" class="w-full" placeholder="0000-000"/>
                                </div>
                                <div class="flex-auto">
                                    <div class="flex flex-row space-x-2">
                                        <jet-label for="localidade" value="Localidade" class="font-bold text-xs" />
                                        <jet-input-error :message="form.errors.localidade" />
                                    </div>
                                    <jet-input type="text" v-model="form.localidade" class="w-full"/>
                                </div>
                            </div>

                            <div class="flex space-x-4 w-full mt-2">
                                <!-- Telefone -->
                                <div class="w-full">
                                    <div class="flex flex-row space-x-2">
                                        <jet-label for="tel" value="Tel" class="font-bold text-xs" />
                                        <jet-input-error :message="form.errors.tel" />
                                    </div>
                                    <jet-input type="text" v-model="form.tel" class="w-full"/>
                                    
                                </div>
                                <!-- Email -->
                                <div class="w-full">
                                    <div class="flex flex-row space-x-2">
                                        <jet-label for="email" value="Email" class="font-bold text-xs" />
                                        <jet-input-error :message="form.errors.email" />
                                    </div>
                                    <jet-input type="text" v-model="form.email" class="w-full"/>
                                </div>
                            </div>
                            <!-- Habilitações -->
                            <div class="mt-2">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="habilitacoes" value="Habilitações Literárias" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.habilitacoes" />
                                </div>
                                 <select-input name="form.habilitacoes" v-model="form.habilitacoes" label="">
                                    <option value="" disabled>Habilitações Literárias</option>
                                    <option value="Menos de 4 anos de Escolaridade">MENOS DE 4 ANOS DE ESCOLARIDADE</option>
                                    <option value="4 anos de escolaridade (1.º ciclo do ensino básico)">4 ANOS DE ESCOLARIDADE (1.º ciclo do ensino básico)</option>
                                    <option value="6 anos de escolaridade (2.º ciclo do ensino básico)">6 ANOS DE ESCOLARIDADE (2.º ciclo do ensino básico)</option>
                                    <option value="9º ano  (3.º ciclo do ensino básico)">9.º ANO (3.º ciclo do ensino básico)</option>
                                    <option value="11º ano">11.º ANO</option>
                                    <option value="12º ano (ensino secundário)">12.º ANO (ensino secundário)</option>
                                    <option value="Curso tecnológico (Nível III)">CURSO TECNOLÓGICO/PROFISSIONAL/OUTROS (Nível III)</option>
                                    <option value="Bacharelato">BACHARELATO</option>
                                    <option value="Licenciatura">LICENCIATURA</option>
                                    <option value="Pós-graduação">PÓS-GRADUAÇÃO</option>
                                    <option value="Mestrado">MESTRADO</option>
                                    <option value="Doutoramento">DOUTORAMENTO</option>
                                    <option value="Curso de especialização tecnológica">CURSO DE ESPECIALIZAÇÃO TECNOLÓGICA</option>
                                    <option value="Habilitação ignorada">HABILITAÇÃO IGNORADA</option>
                                </select-input>   
                            </div>
                             <!-- Experiencia profissional -->
                            <div class="mt-2">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="exp_pro" value="Experiência profissional" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.exp_pro" />
                                </div>
                                <text-area-input v-model="form.exp_pro" rows="2" class="w-full" placeholder="Empresa, Função, Anos/Meses"></text-area-input>
                                
                            </div>
                            <!-- disponibilidade -->
                            <div class="mt-2 flex flex-row space-x-2">
                                <div class="flex-1">
                                    <div class="flex flex-row space-x-2 items-center">
                                        <jet-label for="disponibilidade" value="Disponibilidade imediata?" class="font-bold text-xs" />
                                        <jet-input-error :message="form.errors.disponibilidade" />
                                    </div>
                                    <select-input name="form.disponibilidade" v-model="form.disponibilidade" label="">
                                        <option value="Sim">Sim</option>
                                        <option value="Não">Não</option>
                                    </select-input>
                                </div>
                                <div class="flex-1">
                                     <div v-show="form.disponibilidade == 'Não'">
                                        <div class="flex flex-row space-x-2">
                                            <jet-label for="disponibilidade_alt" value="Outra" class="font-bold text-xs" />
                                            <jet-input-error :message="form.errors.disponibilidade_alt" />
                                        </div>
                                        <jet-input type="text" v-model="form.disponibilidade_alt" class="w-full" placeholder="ex: a partir do dia ..."/>
                                    </div>
                                </div>
                            </div>

                            <input type="hidden" v-model="pfield">

                            <!-- Curriculo -->
                            <div class="mt-2">
                                <jet-label for="file" value="Carregar Currículo(pdf)" class="font-bold text-xs" />
                                <jet-input type="file" ref="curriculo" multiple  @change="getFile" />
                            </div>
                        </form>
                   

                        <div class="mt-8 flex items-center">
                            <div>
                                <jet-checkbox v-model="form.rgpd" class="mr-2" value=""></jet-checkbox> Li e aceito a <a :href="route('pol_privacidade')" class="text-violet-500 underline">Política de Privacidade</a>
                                <jet-input-error :message="form.errors.rgpd" />

                            </div>
                            <div class="flex flex-row justify-end flex-1">
                                <jet-secondary-button @click="cancel">Cancelar</jet-secondary-button>

                                <jet-button @click.prevent="createCandidato" class="ml-2 bg-violet-500 hover:bg-violet-600">Enviar</jet-button>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    </front-layout>
</template>

<style>
    @media print {
        .no-print {visibility:hidden;}
        .print {visibility:visible;}
    }
</style>


<script>
    import { defineComponent } from 'vue'
    import FrontLayout from '@/Layouts/FrontLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import JetButton from '@/Jetstream/Button.vue'
    import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue'
    import JetModal from '@/Jetstream/Modal.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetDialogModal from '@/Jetstream/DialogModal.vue'
    import Icon from '@/Jetstream/Icon.vue'
    import JetFormMain from '@/Jetstream/MainForm.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import JetInputError from '@/Jetstream/InputError.vue'
    import TextAreaInput from '@/Jetstream/TextAreaInput.vue'
    import JetCheckbox from '@/Jetstream/Checkbox.vue'
    import SelectInput from '@/Components/SelectInput'
   

    export default defineComponent({
        components: {
            Head,
            Link,
            JetButton,
            JetModal,
            JetDialogModal,
            FrontLayout,
            Icon,
            JetInput,
            JetSecondaryButton,
            JetFormMain,
            JetLabel,
            JetInputError,
            TextAreaInput,
            SelectInput,
            JetCheckbox,
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            categories: Array,
            job: Object,
        },
        data() {
            return {
                pfield: '',
                showReplyForm: false,
                url: '',
                form: this.$inertia.form({
                    nome: '',
                    doc_tipo: '',
                    doc_num: '',
                    nif_num: '',
                    data_nasc: '',
                    morada: '',
                    localidade: '',
                    cod_postal: '',
                    tel: '',
                    email: '',
                    habilitacoes: '',
                    exp_pro: '',
                    disponibilidade: '',
                    disponibilidade_alt: '',
                    curriculo: null,
                    rgpd: ''
                })
            }
        },
        created(){
            this.url = 'https://www.facebook.com/sharer/sharer.php?u=' + window.location.origin + '/ofertas-de-emprego/' + this.job.slug

            this.job.description = this.job.description ? this.job.description.replace(/\n/g, "<br>\n") : null;
            this.job.functions = this.job.functions ? this.job.functions.replace(/\n/g, "<br>\n") : null;
            this.job.reqs = this.job.reqs ? this.job.reqs.replace(/\n/g, "<br>\n") : null;
            this.job.offers = this.job.offers ? this.job.offers.replace(/\n/g, "<br>\n") : null;
            this.job.notes = this.job.notes ? this.job.notes.replace(/\n/g, "<br>\n") : null;
        },
        methods: {
            createCandidato() {
                if(this.pfield == '') {
                    this.form.post(route('create.candidato', {
                        'job_id': this.job.id
                    }), {
                        preserveScroll: true,
                        onSuccess: () => (
                            this.form.reset(),
                            this.showReplyForm = false
                        ),
                    }); 
                }
            },
            getFile(event) {
                this.form.curriculo = event.target.files
            },
            cancel() {
                this.form.reset()
                this.showReplyForm = false
            },
            print() {
                window.print()
            }
        }
    })
</script>